module.exports = __webpack_public_path__ + "static/media/brisbane-lions-logo.f38b796d.svg";